// extracted by mini-css-extract-plugin
export var contentBody = "_7r-9";
export var headerImage = "_7r-2";
export var imageButton = "_7r-7";
export var imageButtonIcon = "_7r-8";
export var imageHeader = "_7r-4";
export var imageHeaderText = "_7r-5";
export var imageOverlay = "_7r-3";
export var imageTitle = "_7r-6";
export var imageWrapper = "_7r-1";
export var taskList = "_7r-a";
export var widget = "_7r-0";